import { HashRouter, Routes, Route } from 'react-router-dom';
import HomePage from '@/pages/Home';
import Dashboard from '@/pages/Dashboard';
import LeadDetail from '@/pages/LeadDetail';
import GuaranteePage from '@/pages/Guarantee';
import InstallerPage from '@/pages/InstallerPage';
import ProposalGenerator from '@/pages/ProposalGenerator';
import NotFound from '@/pages/not-found';

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/garantia" element={<GuaranteePage />} />
        <Route path="/instalador" element={<InstallerPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/lead/:id" element={<LeadDetail />} />
        <Route path="/proposta" element={<ProposalGenerator />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </HashRouter>
  );
}
